import { Component, Prop, Vue } from 'vue-property-decorator'
import { AiAnalysisStatusIconState } from '@/cellRenderers/common/ai-analysis-status/ai-analysis-status-icon.model'

@Component
export default class AiAnalysisStatusIcon extends Vue {
    @Prop() readonly status!: AiAnalysisStatusIconState
}
